import React from 'react';

import styles from '../Filters.module.scss';

import { GetPlanId } from '../../../../helpers/Helpers';

import TimeSidebar from './TimeSidebar';
import PageLoader from '../../loader/PageLoader';

import { ITimeFilter } from '../../../../interfaces/filters.interface';
import { GetTimeList, UpdateTimeList } from '../../../../api-services/filters.api';

interface Props {
  isSingle: boolean;
  history?: any;
  selectedData: any;
  updateSelection: (status) => void;
}

interface State {
  showSidebar: boolean;
  timeList: ITimeFilter[];
  selectedTimeList: ITimeFilter[];
  isLoading: boolean
}

export default class TimeFilter extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      showSidebar: false,
      timeList: [],
      selectedTimeList: !!this.props.selectedData ? this.props.selectedData.time : [],
      isLoading: false
    };
  }

  getTimeList(): void {
    const params = {
      userId: sessionStorage.getItem('userName'),
    };

    this.setState({ isLoading: true });

    GetTimeList(params)
      .then((res: {
        time: ITimeFilter[],
      }) => {
        if (!!res) {
          this.setState({
            timeList: res.time,
            showSidebar: true,
            isLoading: false
          });
        }
      });
  }

  updateTimeList(dataSource): void {
    const payload: {time: ITimeFilter[]} = {
      time: dataSource
    };

    const params = {
      planId: GetPlanId(this.props.history.location.pathname)
    };

    UpdateTimeList(payload, params)
      .then((res) => {
        if (!!res) {
          this.props.updateSelection(true);
          this.setState({
            selectedTimeList: dataSource,
            showSidebar: false
          });
        }
      });
  }

  displaySelectedItems(): string {
    const isAnySelected = this.state.selectedTimeList.reduce((acc, year) => {
      acc = acc || year.quarters.reduce((init, quarter) => {
        init = init || quarter.selected;
        return init;
      }, false);
      return acc;
    }, false);

    if (!isAnySelected) {
      return 'N/A';
    }

    const selectedStr = this.state.selectedTimeList.reduce((acc, year, idx) => {
      const isAnyQuarterSelected = !!year.quarters.filter((quarter) => quarter.selected).length;

      if (isAnyQuarterSelected) {
        acc = acc + year.name + ': ' + year.quarters
          .filter((quarter) => quarter.selected)
          .map((quarter) => quarter.name)
          .join(', ');
      }

      return acc + (this.state.selectedTimeList.length - 1 !== idx ? (!!acc ? ', ' : '') : '');
    }, '');

    return selectedStr.slice(-2) === ', ' ? selectedStr.slice(0, -2) : selectedStr;
  }

  render(): React.ReactNode {
    return (
      <React.Fragment>
        <PageLoader
          status={this.state.isLoading}
          fromFilter={true}
        />
        <p
          className={styles['filter-label']}
          onClick={() => this.getTimeList()}
        >
          Time
        </p>
        <p className={styles['filter-value']}>
          {this.displaySelectedItems()}
        </p>

        {
          this.state.showSidebar &&
          <TimeSidebar
            isSingle={this.props.isSingle}
            timeList={this.state.timeList}
            onHideSidebar={() => this.setState({ showSidebar: false })}
            onSave={(dataSource) => this.updateTimeList(dataSource)}
          />
        }
      </React.Fragment>
    );
  }
}
